import {
  Home as HomeIcon,
  Info as AboutIcon,
  Person as ProfileIcon,
  AddCircleOutline as CreatePostIcon,
  Edit as EditPostIcon,
  BookmarkBorder as SavedPostsIcon,
  Dashboard as DashboardIcon,
  Feedback as FeedbackIcon,
  ExitToApp as LogoutIcon,
  Explore as ExploreIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import ArticleIcon from '@mui/icons-material/Article';

// Main navigation items (appear in header)
export const MAIN_NAV_ITEMS = [
  { 
    name: "Posts", 
    path: "/fmr/posts", 
    icon: <ArticleIcon fontSize="small" />,
    role: ['user', 'admin', 'guest'] // Role-based access
  },
  // { 
  //   name: "Explore", 
  //   path: "/fmr/explore", 
  //   icon: <ExploreIcon fontSize="small" />,
  //   role: ['user', 'admin', 'guest']
  // },
  { 
    name: "About us", 
    path: "/fmr/about-us", 
    icon: <AboutIcon fontSize="small" />,
    role: ['user', 'admin', 'guest']
  }
];

// User dropdown menu items
export const USER_MENU_ITEMS = (hasPost) => [
  { 
    name: "Profile", 
    path: "/fmr/profile", 
    icon: <ProfileIcon fontSize="small" />,
    divider: false
  },
  { 
    name: hasPost ? "Edit post" : "Create post", 
    path: "/fmr/create-post", 
    icon: hasPost ? <EditPostIcon fontSize="small" /> : <CreatePostIcon fontSize="small" />,
    divider: false
  },
  { 
    name: "Saved posts", 
    path: "/fmr/saved-posts", 
    icon: <SavedPostsIcon fontSize="small" />,
    divider: false
  },
  // { 
  //   name: "Notifications", 
  //   path: "/fmr/notifications", 
  //   icon: <NotificationsIcon fontSize="small" />,
  //   divider: false
  // },
  // { 
  //   name: "Settings", 
  //   path: "/fmr/settings", 
  //   icon: <SettingsIcon fontSize="small" />,
  //   divider: true
  // },
  { 
    name: "User Feedback", 
    path: "/fmr/user-feedback", 
    icon: <FeedbackIcon fontSize="small" />,
    divider: true
  },
  { 
    name: "Logout", 
    path: null, // Special case handled differently
    icon: <LogoutIcon fontSize="small" />,
    divider: false
  }
];